import React, { forwardRef } from "react"

import styles from './mission_vision.module.css';

const MissionVision = forwardRef((props, ref) => {
    return (
        <figure className={styles.figure} ref={ref}>
            <img src="./images/mission_vision/planet1.jpg" alt="mission"></img>

            <article className={styles.txt}>
                <div>MISSION</div>
                <h2>Let's go to a smart planet together. </h2>
                <p>최신 IT 기술로 세상을 재미있게 변화시킨다. 스마트 팜은 AI 두뇌와 로봇의 노동력으로, 스마트 시티는 도시 데이터를 분석하여 모두가 살기 좋은 도시로 발전한다. 그리고 로봇, 드론, 자율주행의 실현은 모든 분야에서 육체 노동으로부터 해방을 의미한다. 해방된 사람은 문화의 부흥을 일으키고, 폭발적인 기술 발전을 낳고, 결과적으로 우주로 나가서 새로운 행성에 정착한다.</p>
            </article>

            <article className={styles.phone_txt}>
                <div>MISSION</div>
                <h2>Let's go to a smart planet together. </h2>
                <p>최신 IT 기술로 세상을 재미있게 변화시킨다. 스마트 팜은 AI 두뇌와 로봇의 노동력으로, 스마트 시티는 도시 데이터를 분석하여 모두가 살기 좋은 도시로 발전한다.</p>
                <p>그리고 로봇, 드론, 자율주행의 실현은 모든 분야에서 육체 노동으로부터 해방을 의미한다. 해방된 사람은 문화의 부흥을 일으키고, 폭발적인 기술 발전을 낳고, 결과적으로 우주로 나가서 새로운 행성에 정착한다.</p>
            </article>
        </figure>
    )
});

export default React.memo(MissionVision);